import { InjectionToken, inject } from '@angular/core';

export const WINDOW = new InjectionToken<Window>('Global window object', {
  providedIn: 'root',
  factory: () => window
});

export const LOCAL_STORAGE = new InjectionToken<Storage>('Global window local storage', {
  providedIn: 'root',
  factory: () => {
    const window = inject(WINDOW);
    return window.localStorage;
  }
});

export const SESSION_STORAGE = new InjectionToken<Storage>('Global window session storage', {
  providedIn: 'root',
  factory: () => {
    const window = inject(WINDOW);
    return window.sessionStorage;
  }
});
